module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/issue-03-32da2becf37c02e07972188b92a4fdde.png";